import React, { useState, useEffect } from 'react';
import "./tableStyle.css"
import { getclientslist } from '../../Services/Services';
import { Col, Input, Button, Form } from 'antd';
import AddNewClients from './AddNewClients';
import EditClients from './EditClients'
import Header from '../Header-Footer/Header';
import * as XLSX from 'xlsx'; // Import xlsx library
import Footer from '../Header-Footer/Footer'
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { FaFilePdf, FaFileExcel } from 'react-icons/fa';

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [clientDetails, setclientDetails] = useState([])
  const [form] = Form.useForm();
  useEffect(() => {
    GetClients();
  }, []);

  const GetClients = async () => {
    const response = await getclientslist();
    if (response) {
      const sortedArray = [...response.client_list].sort((a, b) => b.client_id - a.client_id);
      const filterData = sortedArray.filter(o => o.com_name === localStorage.getItem('com_name'))
      setClients(filterData);
      setclientDetails(filterData)
    }
  }
  const handleValuesChange = (changedValues, allValues) => {
    const filteredData = clientDetails.filter(item =>
      item.client_name.toLowerCase().includes((allValues.client_name || '').toLowerCase()) &&
      item.pan_no.toLowerCase().includes((allValues.pan_no || '').toLowerCase())
    );

    setClients(filteredData);
  };
  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = clients.map((e, index) => [
      index + 1,
      e.client_name,
      e.contact_no,
      e.pan_no,
      e.gst_no,
      e.Address,
      e.moisture_per
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ['Sr. No', 'Party Name', 'Contact No.', 'Gst No', 'Pan No', 'Address', 'Moisture %'],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'DeliveryOrder');

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'Client List.xlsx');
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [clientData, setClientData] = useState()
  const findClient = (id) => {
    setClientData(clients.find(o => o.client_id === id))
  }
  return (
    // <div>
      <div style={{ height:'90vh' }}>
      <Header heading="PARTY VIEW" />
      <Form
        form={form}
        layout="vertical"
        onValuesChange={handleValuesChange}
      >
        <div className=" grid grid-cols-1 sm:grid sm:grid-cols-3 sm:gap-2 m-auto px-5 sm:w-[100%]  md:w-[100%]">
          <Col>
            <label><b>Party Name</b></label><br />
            <Form.Item
              name='client_name'
            >
              <Input
                placeholder='Search by Party Name'

              />
            </Form.Item>
          </Col>
          <Col>
            <label><b>Pan Number</b></label><br />
            <Form.Item
              name='pan_no'
            >
              <Input
                placeholder='Search by Pan Number'
              />
            </Form.Item>
          </Col>
          <Col>
            <AddNewClients setClients={setClients} setclientDetails={setclientDetails} />


            <Button
              style={{

                top:'13px',
                margin: "10px",
                backgroundColor: 'black',
                color: 'white',
                fontWeight: '600'
              }}
              onClick={handlePrint}
            >
              <FaFilePdf/>
            </Button>
            <Button
              style={{
                top:'13px',
                margin: " 10px",
                backgroundColor: 'green',
                color: 'white',
                fontWeight: '600'
              }}
              onClick={handleExportToExcel}
            >
              <FaFileExcel /> 
            </Button>
          </Col>
        </div>
      </Form>
      <div className="table-wrapper" ref={componentRef} style={{ maxHeight: "500px", overflowX: "auto", overflowY: "auto" }}>
        <table id="my-table" className="w-full">
          <thead className="bg-[#fff] w-full text-white" style={{}}>
            <tr >
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Sr. No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Id</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Party Name</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Contact No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Gst No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Pan No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Address</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Moisture %</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Action</th>

            </tr>
          </thead>
          <tbody>
            {clients.map((e, index) => (
              <tr key={e.client_id}>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{index + 1}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.client_id}</td>

                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.client_name}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.contact_no}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.gst_no}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.pan_no}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.Address}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.moisture_per}</td>
                <td>
                  <button onClick={() => findClient(e.client_id)}>
                    <EditClients setClients={setClients} setclientDetails={setclientDetails} clientData={clientData} />
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* <Footer /> */}

    </div>
  )
}


 